import { Button } from "@mui/material";
import { Text } from "../../../Text";

const deleteAllCookies = () => {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
};
function onClick() {
  localStorage.clear(); // clean storage
  sessionStorage.clear(); // clean storage
  deleteAllCookies();
  window.location.reload(true); // hard reload
}

export function CleanCache() {
  return (
    <Button size="small" variant="text" color="primary" onClick={onClick}>
      <Text value={"Clear cache"} />
    </Button>
  );
}
